<script>

import Vue from "vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import BirimSecimi from "../FormComponet/BirimSecimiAnaBirim.vue";


import verigirisraporu from './ProsesRaporlari/verigirisraporu.vue';
import gerceklesmebirim from './ProsesRaporlari/gerceklesmebirim.vue';
import gerceklesmekurum from './ProsesRaporlari/gerceklesmekurum.vue';



export default {
  mixins: [Api, Sabit],
  page: {
    title: "Proses Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    BirimSecimi,
    verigirisraporu,
    gerceklesmekurum,
    gerceklesmebirim,
  

  },
  data() {
    return {
      title: "Proses raporları",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Raporlar",
          active: true,
        },
        {
          text: "Proses Raporları",
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      counter: 0,
      UstDonemId: null,
      secilen_birim: "",
      secilen_donem: "",
      secilen_alt_donem:"",
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      ComboboxGDonemler: [],
      ComboboxBirimler: [],
      YuklenenTablolar: [],
      TabloDetaylar: [],
      Isbirlikciler: [],
      TabloDetay:{},
      Secilen: null,
      sorgula:0,
      Raporgirisid: "",
      DetayId:"",
      TabloDetayAciklama:"",
      DonemId:"",
      Hesaplanmasin:"",
      AltDonemlerDetay:[],
      BirimId:"",
      Tablo:0,
      Filter: {
        DonemId: "",
        GdonemId: "",
        KdonemId:"",
        BirimId: null,
        BirimAdi:""
      },
    };
  },

  methods: {
    /* ANCHOR Combobox yükleme metodları */
    gdonem_combo_yukle(ust_id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.Filter.GdonemId="";
      this.UstDonemId = ust_id;

      this.ComboboxGDonemler = [];


      let Filter = "&UstId=" + ust_id+"&VeriTipi=3&Asc=Aciklama";
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page, Filter:Filter}).then((res) => {
        this.ComboboxGDonemler = res.Data;

      });

      
    },

    Secilmis_Idler(secilmis) {
      this.Filter.BirimId=secilmis;  
      this.Filter.BirimAdi=secilmis;   
    },



    tablo_combo_yukle(birim_id) {
        if (this.Filter.DonemId != null && this.Filter.DonemId != "") {
            this.secilen_birim = birim_id;
            this.secilen_donem = this.UstDonemId;

            //this.gdonem_combo_yukle(this.UstDonemId);
        } else {
            this.makeToast();
        }
    },

    /* ANCHOR yükleme butonu kodu */
    tablo1_yukle() { //veri giriş raporu
      
       if (this.Filter.GdonemId!="" && this.Filter.GdonemId!=null) {
     
        this.Tablo=1;
        this.sorgula=this.sorgula+1;

      } else {
            this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = this.$t('ProsesRaporlari.Mesajlar.Tablo1Mesaj');
            this.Message.showConfirmButton = false;
            this.Message.timer = 1000;

            Vue.swal(this.Message);
      }
    },

    tablo2_yukle() { //Gerçekleşme Oranları kurum bazlı
      
        if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
        this.Filter.GdonemId!="" && this.Filter.GdonemId!=null ) {
     
        this.Tablo=2;
        this.sorgula=this.sorgula+1;

      } else {
            this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = this.$t('ProsesRaporlari.Mesajlar.Tablo2Mesaj');
            this.Message.showConfirmButton = false;
            this.Message.timer = 2000;

            Vue.swal(this.Message);
      }
    },

    tablo3_yukle() { //Gerçekleşme Oranları birim bazlı
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null && 
      this.Filter.BirimId!="" && this.Filter.BirimId!=null && this.Filter.BirimId
       ) {
   
      this.Tablo=3;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('ProsesRaporlari.Mesajlar.Tablo3Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },




    Get() {
  
    },

    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },

  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==6 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  this.ComboboxDonemler.push(res.Data[i]);
                  
                }
              });
         
            });



    this.ActionsGet({"Service":"OBirim", "Page":Page}).then((res) => {
      this.ComboboxBirimler = res.Data;
    });
  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <!-- ANCHOR Filtreleme form alanı -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-5">

                  <b-form-group
                    class="mb-3"
                    id="donemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.DonemId"
                      @change="gdonem_combo_yukle(Filter.DonemId)"
                      class="form-select"
                      type="text"
                    >
                      <option value=""
                        >{{$t('ProsesRaporlari.Filtreleme.UstId')}}</option
                      >
                      <option
                        v-for="DonemVerileri in ComboboxDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                       {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>
                     <!--{{Filter.DonemId}}--> 


                  <b-form-group
                    class="mb-3"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.GdonemId"
                      class="form-select"
                      type="text"
                    >
                      <option value="">{{this.$t('ProsesRaporlari.Filtreleme.DonemId')}}</option>
                      <option
                        v-for="DonemVerileri in ComboboxGDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                        {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>
                <!-- {{Filter.GdonemId}} -->



                  <BirimSecimi
                    :title="''"
                    :title_class="'mb-3'"
                    :closeOnSelect="true"
                    :sutun="'0'"
                    :multiple="false"
                    :YetkiKontrol="0"
                    :personel_id="null"
                    :BirimTipId="null"
                    @Secilmis_Idler="Secilmis_Idler($event)"
                     
                  />      
                </div>

                <!-- ANCHOR Rapor Çıktıları alanı -->
                <div class="col-md-7">
               
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap table-centered table-hover mb-0 align-middle"
                        >
                          <tbody>
                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                 
                                  <a href="javascript: void(0);"
                                    @click="tablo1_yukle()"
                                    class="text-dark">
                                    <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('ProsesRaporlari.Raporlar.verigiris')}}</span>
                                    </a>
                                </h5>
                              </td>
                               <td>
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="tablo2_yukle()"
                            
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('ProsesRaporlari.Raporlar.gerceklesmekurum')}}</span></a
                                  >
                                </h5>
                              </td>
                            </tr>
                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                 
                                  <a href="javascript: void(0);"
                                    @click="tablo3_yukle()"
                                    class="text-dark">
                                    <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('ProsesRaporlari.Raporlar.gerceklesmebirim')}}</span>
                                    </a>
                                </h5>
                              </td>
                               <td>
                                <h5 class="font-size-14 mb-0">
                            
                                </h5>
                              </td>
                            </tr>

                       
         
                            
                            
                         
                          </tbody>
                        </table>
                      </div>
                    
                  <br>
                  <br>
                </div>

              </div>
            </div>
          </div>
        </div>



      </div>

      
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

                
                <verigirisraporu v-if="Tablo==1"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <gerceklesmekurum v-if="Tablo==2"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <gerceklesmebirim v-if="Tablo==3"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                

    

            </div>
          </div>
        </div>
      </div>

    



    </Layout>
  </Loader>
</template>

